export const ASSETS = {
  "cards": {
    "cardBack": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1f4f169fec004b8581d8cdec1bb24bbb/main/preview/assets/cards/card_back.png",
      "height": 300,
      "width": 300
    }
  },
  "faces": {
    "face1": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_light_blue.png",
      "height": 300,
      "width": 300
    },
    "face10": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_pink.png",
      "height": 300,
      "width": 300
    },
    "face2": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_purple.png",
      "height": 300,
      "width": 300
    },
    "face3": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_orange.png",
      "height": 300,
      "width": 300
    },
    "face4": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_dark_red.png",
      "height": 300,
      "width": 300
    },
    "face5": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_light_green.png",
      "height": 300,
      "width": 300
    },
    "face6": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_red.png",
      "height": 300,
      "width": 300
    },
    "face7": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_yellow.png",
      "height": 300,
      "width": 300
    },
    "face8": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_dark_blue.png",
      "height": 300,
      "width": 300
    },
    "face9": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8b52c02e561d4ddbb2de0c3d911e1568/main/preview/assets/characters/dust_bunny_green.png",
      "height": 300,
      "width": 300
    }
  },
  "music": {
    "backgroundMusic": {
      "path": "https://ucarecdn.com/ff88ed1d-3459-457e-9234-afe5aff1488b/jazz-vibe-youtube-velvet-corners-382856.mp3",
      "height": 300,
      "width": 300
    }
  },
  "sfx": {
    "bust_sound": {
      "path": "https://ucarecdn.com/c06b7ca4-2bcd-4e1e-8a7f-2f28c28c513b/busted.wav",
      "height": 300,
      "width": 300
    },
    "button_click": {
      "path": "https://ucarecdn.com/3c7e001c-9a89-4963-bc04-8a9a0eeec51c/button1.wav",
      "height": 300,
      "width": 300
    },
    "card_draw": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b1370004048f40cbb2a18807cb6ad16b/37830fe6e7bd4a7db2166862f6ab7814/preview/assets/sfx/card_draw.ogg"
    },
    "card_place": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b1370004048f40cbb2a18807cb6ad16b/37830fe6e7bd4a7db2166862f6ab7814/preview/assets/sfx/card_place.ogg"
    },
    "game_over": {
      "path": "https://ucarecdn.com/75b33a1e-4568-4956-95ca-57942509d739/gameOver.wav",
      "height": 300,
      "width": 300
    },
    "steal_sound": {
      "path": "https://ucarecdn.com/6376f050-c084-41a0-80c8-bd7a74a39a22/steal.wav",
      "height": 300,
      "width": 300
    },
    "turn_end": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b1370004048f40cbb2a18807cb6ad16b/37830fe6e7bd4a7db2166862f6ab7814/preview/assets/sfx/turn_end_chime.ogg"
    }
  }
};
